import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/herdotandco/footer';
import Header from '../components/herdotandco/header';
import HomePage from '../pages/herdotandco/home_page';
import AboutPage from '../pages/herdotandco/about_page';
import ContactPage from '../pages/herdotandco/contact_page';


export default function HerdotandcoTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
                
            />
            <Footer />
        </React.Fragment>
    )
}
